import { AttackTypes } from "../../constants/enums";

export const handleAttackPreSubmit = (form, setError, callback) => {
  if (!form.name) {
    setError("Name is required");
    return;
  } else if (!form.description) {
    setError("Description is required");
    return;
  } else if (!form.status) {
    setError("Status is required");
    return;
  } else if (
    !form.shortName ||
    form.shortName === "" ||
    form.shortName?.length > 30
  ) {
    setError("Short Name is required in less than 30 characters");
    return;
  } else if (!form.categoryIds || form.categoryIds?.length === 0) {
    setError("Category is required");
    return;
  } else if (!form.categoryTypeIds || form.categoryTypeIds.length === 0) {
    setError("Type is required");
    return;
  } else if (!form.attackPhase || form.attackPhase.length === 0) {
    setError("Attack Phase is required");
    return;
  } else if (!form.preventionControls || form.preventionControls.length === 0) {
    setError("Prevention Controls is required");
    return;
  } else if (!form.target) {
    setError("Target is required");
    return;
  } else if (form.supportedPlatforms.length === 0) {
    setError("Supported Platforms cannot be empty");
    return;
  } else if (form.executors.length === 0) {
    setError("Executors cannot be empty");
    return;
  } else if (form.affectedPrograms.length === 0) {
    setError("Affected Program is required");
    return;
  } else if (form.references.length === 0) {
    setError("References cannot be empty");
    return;
  } else if (
    form.authentication === true &&
    (!form.credentialType || form.credentialType === "")
  ) {
    setError("Credential Type is required when Authentication is enabled");
    return;
  } else if (
    (() => {
      if (form.recommendation.length > 0) {
        const val = form.recommendation
          .split("<br/>")
          .every((x) => x.length > 0);
        return !val;
      } else {
        return true;
      }
    })()
  ) {
    setError("Recommendation is required");
    return;
  }

  callback({ ...form });
};
